import classnames from 'classnames';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import { SdsButtonStyled } from './SdsButtonStyled';

const POS_LEFT = 'left';
const POS_RIGHT = 'right';

class SdsButton extends PureComponent {

  render() {

    const {
      type,
      raised,
      outlined,
      flat,
      primary,
      secondary,
      waves,
      disabled,
      rounded,
      iconPlacement = POS_LEFT,
      icon,
      label,
      pureLabel,
      fullwidth,
      className,
      br20,
      isIcon = false,
      govBr = false
    } = this.props;

    let propsToPass = { ...this.props };
    delete propsToPass.type;
    delete propsToPass.raised;
    delete propsToPass.outlined;
    delete propsToPass.flat;
    delete propsToPass.primary;
    delete propsToPass.secondary;
    delete propsToPass.waves;
    delete propsToPass.disabled;
    delete propsToPass.icon;
    delete propsToPass.iconPlacement;
    delete propsToPass.label;
    delete propsToPass.pureLabel;
    delete propsToPass.rounded;
    delete propsToPass.fullwidth;
    delete propsToPass.className;

    const cssButton = classnames(
      {
        'sds-btn': true,
        'sds-btn--disabled': disabled,
        'sds-btn--raised': raised,
        'sds-btn--outlined': outlined,
        'sds-btn--flat': flat,
        'sds-btn--primary': primary,
        'sds-btn--secondary': secondary,
        'sds-waves-effect': waves,
        'sds-btn--rounded': rounded,
        'sds-btn--icon': icon && !label,
        'sds-btn--full-width': fullwidth
      },
      className
    );

    const cssIcon = classnames('material-icons', {
      'sds-btn__icon': icon && label,
      'sds-btn--right': iconPlacement === POS_RIGHT
    });

    return (
      <SdsButtonStyled
        br20={br20}
        type={type}
        className={cssButton}
        disabled={disabled}
        isIcon={isIcon}
        govBr={govBr}
        {...propsToPass}
      >
        {iconPlacement === POS_LEFT && <i className={cssIcon}>{icon}</i>}
        {(label && !pureLabel) ? <FormattedMessage id={label} /> : pureLabel}
        {iconPlacement === POS_RIGHT && <i className={cssIcon}>{icon}</i>}
      </SdsButtonStyled>
    );
  }
}

SdsButton.defaultProps = {
  type: "button",
  raised: false,
  outlined: false,
  flat: false,
  primary: false,
  secondary: false,
  waves: true,
  disabled: false,
  rounded: false,
  iconPlacement: POS_LEFT,
  fullwidth: false
};

SdsButton.propTypes = {
  type: PropTypes.string,
  raised: PropTypes.bool,
  outlined: PropTypes.bool,
  flat: PropTypes.bool,
  primary: PropTypes.bool,
  secondary: PropTypes.bool,
  waves: PropTypes.bool,
  disabled: PropTypes.bool,
  rounded: PropTypes.bool,
  iconPlacement: PropTypes.string,
  icon: PropTypes.string,
  label: PropTypes.string,
  pureLabel: PropTypes.string,
  fullwidth: PropTypes.bool,
  className: PropTypes.string
};

export default SdsButton;